module.exports = __webpack_public_path__ + "img/yabberer.98cc2c46.svg";